import PropTypes from "prop-types";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useShallow } from "zustand/react/shallow";
import { useDeliveryNoteTemplatesStore } from "../../stores/delivery_note_templates";
import Modal, { ModalBody, ModalFooter, ModalHeader } from "./Modal";

import "../../scss/select-template-dialog.scss";

// Template picker shown before creating a delivery note from a work order.
function SelectTemplateDialog({ onSelect, onClose }) {
  const { t } = useTranslation();
  const { templatesByIds, templatesAllIds, fetchTemplates } = useDeliveryNoteTemplatesStore(
    useShallow((state) => ({
      templatesByIds: state.byIds,
      templatesAllIds: state.allIds,
      fetchTemplates: state.fetchSome,
    })),
  );
  const templates = templatesAllIds.map((id) => templatesByIds[id]).filter(Boolean);

  useEffect(() => {
    fetchTemplates({ q: "", limit: 100, offset: 0 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal>
      <ModalHeader>
        <h5 className="modal-title">{t("work_orders.choose_template")}</h5>
      </ModalHeader>
      <ModalBody>
        <div className="list-group select-template-dialog">
          {templates.map((template) => (
            <button
              key={template.id}
              type="button"
              className="list-group-item list-group-item-action"
              onClick={() => onSelect(template.id)}
            >
              <i className="fa fa-file-lines fa-fw me-2" />
              {template.name}
            </button>
          ))}
        </div>
      </ModalBody>
      <ModalFooter>
        <button type="button" className="btn btn-default" onClick={onClose}>
          {t("menu.cancel")}
        </button>
      </ModalFooter>
    </Modal>
  );
}

SelectTemplateDialog.propTypes = {
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SelectTemplateDialog;
